import isDigitalAsset from './isDigitalAsset';

const isMoreThanInStock = (product, count, multiplier = 1) => {
  if (!product || isDigitalAsset(product)) {
    return false;
  }

  return count * multiplier > product.product_available_qty;
};

export default isMoreThanInStock;
